// extracted by mini-css-extract-plugin
export default {"wrapper":"Sider_wrapper__3mFeT","container":"Sider_container__Tlxu1","title":"Sider_title__iKdbE","icon":"Sider_icon__KqbnE","items":"Sider_items__lvutg"};